import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDAC5sBhfHzRw1gBfmZ6MefW80xjpyVd0I",
  authDomain: "pazaryeri-57419.firebaseapp.com",
  projectId: "pazaryeri-57419",
  storageBucket: "pazaryeri-57419.firebasestorage.app",
  messagingSenderId: "943095534116",
  appId: "1:943095534116:web:7d0f33e65f3893cac3feb1",
  measurementId: "G-428ZW5YT64"
};
 
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

export default app;